import { Component } from "preact";
import { connect } from "react-redux";
import { css } from "emotion";

import {
  getLocale,
  changeLocale,
  initLocale
} from "../state/actions/contentActions";
import Label from "./text/Label";

const icClose = require("../assets/ic_close_x_white.svg");
const dropdownIcon = require("../assets/ic_dropdown_white.svg");

class CountryDetect extends Component {
  constructor(props) {
    super(props);
    const { locale, detectedLocale } = this.props;
    let closed = locale === detectedLocale;
    this.state = {
      closed
    };
  }

  componentDidMount() {
    const { getLocale, content, locale, initLocale } = this.props;
    if (locale) {
      initLocale(locale);
    }
    if (!locale && !content.locale) {
      getLocale();
    }
  }

  closeBanner = () => {
    this.setState({
      closed: true
    });
  };

  changeLocaleFunction = e => {
    const { changeLocale } = this.props;
    changeLocale(e.target.value);
  };

  render() {
    const { content, changeLocale } = this.props;
    const { closed } = this.state;
    const wrapper = css({
      position: "relative",
      top: 0,
      backgroundColor: "#637184",
      zIndex: 99999999,
      padding: "20px 60px 14px 60px",
      color: "white",
      verticalAlign: "top",
      "@media(max-width: 846px)": {
        padding: "16px 14px"
      }
    });

    const drowDown = css({
      fontSize: 16,
      borderRadius: 4,
      backgroundColor: "#4f6077",
      borderColor: "#fff",
      padding: "7px 12px",
      margin: "0 16px",
      color: "#fff",
      verticalAlign: "top",
      paddingRight: 24,
      backgroundImage: `url(${dropdownIcon})`,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "100% 50%",
      option: {
        "&:last-of-type": {
          borderBottomLeftRadius: 4,
          borderBottomRightRadius: 4
        }
      },
      "@media(max-width: 846px)": {
        marginLeft: 0,
        fontSize: 14
      }
    });

    const buttonStyle = css({
      width: 24,
      height: 24,
      background: "transparent",
      backgroundImage: `url(${icClose})`,
      border: "none",
      marginTop: 4,
      position: "absolute",
      top: "calc(50% - 14px)",
      right: 0,
      "@media(max-width: 846px)": {
        top: 16,
        right: 0
      }
    });
    if (closed) {
      return null;
    }
    return (
      <div className={wrapper}>
        <div
          className={css({
            maxWidth: 1200,
            margin: "0 auto",
            position: "relative"
          })}
        >
          <Label
            color="#fff"
            inline
            marginRight={40}
            verticalAlign="sub"
            breakpoint={846}
            maxWidth={216}
            marginBottomMobile={12}
          >
            Choose another country or region to see information specific to your
            area.
          </Label>
          <select onChange={this.changeLocaleFunction} className={drowDown}>
            <option value="au" selected={content.locale === "au"}>
              Australia
            </option>
            <option value="nz" selected={content.locale === "nz"}>
              New Zealand
            </option>
          </select>
          <button onClick={this.closeBanner} className={buttonStyle} />
        </div>
      </div>
    );
  }
}

export default connect(
  (state, ownProps) => ({
    content: state.content
  }),
  { getLocale, changeLocale, initLocale }
)(CountryDetect);
